export default "__VITE_ASSET__B8RA$THi__"